import React from 'react';

type HomeIconProps = {
  size?: number;
  color?: string;
};

const HomeIcon: React.FC<HomeIconProps> = ({
  size = 42,
  color = '#0077D6',
}) => {
  return (
    <svg
      width={size}
      height={(size * 34) / 42}
      viewBox="0 0 42 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99993 34.0002V14.5272L1.81943 17.7272L0.461426 15.9232L5.99993 11.7002V6.32724H8.26942V9.93875L20.9999 0.250244L41.5384 15.9542L40.1804 17.7272L35.9999 14.5272V34.0002H5.99993ZM8.26942 31.7307H18.9804V22.9617H23.0194V31.7307H33.7304V12.8042L20.9999 3.09624L8.26942 12.8042V31.7307Z"
        fill={color}
      />
    </svg>
  );
};

export default HomeIcon;
